<template>
  <div>
    <q-field :error="error" error-label="Invalid User" :helper="helper">
      <q-search v-model="filter" :placeholder="placeholder" v-if="!hide" :clearable="clearable"
          @clear="clearMethod">
        <q-autocomplete 
          ref="userAutoComplete"
          :debounce="500"
          
          :max-results="maxResults"
          @search="onSearch"
          @selected="onSelectMethod"
        />
      </q-search>
    </q-field>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'UserAutoComplete',
  props: {
    onSelect: { },
    userId: { },
    hide: { },
    clearable: { default: false },
    clear: { default: false },
    error: { default: false },
    placeholder : { default : "Start typing a name or email"},
    helper: { default: null }
  },
  mounted () {
  },
  data () {
    return {
      filter: null,
      maxResults: 5
    }
  },
  computed: {
    ...mapGetters('users', [
      'autoCompleteOptions'
    ])
  },
  methods: {
    ...mapActions('users', [
      'fetchAutoComplete'
    ]),
    onSearch (s, done) {
      const USER_ID = this.userId
      this.fetchAutoComplete({ s, USER_ID })
      setTimeout(() => {
        done(this.autoCompleteOptions)
      }, 1000)
    },
    onSelectMethod(val){
      console.log(val)
      if(this.onSelect) this.onSelect(val)
    },
    clearMethod(){
      if(this.onSelect) this.onSelect(null)
      if(this.clear) this.clear()
    }
  }
}
</script>

<style>
</style>
